import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {ICertificateQueryResult} from '../shared/model/certificate-query-result.model';

@Injectable({providedIn: 'root'})
export class CertificateQueryService {
  private resourceUrl = environment.apiConfig.uri + 'api/zeugnisse/abfrage';

  constructor(private http: HttpClient) {}

  query(from: string, to: string, certNames?: string[]): Observable<ICertificateQueryResult[]> {
    const params: Record<string, string | string[]> = {from, to};
    if (certNames && certNames.length > 0) {
      params['zertifikate'] = certNames;
    }
    return this.http.get<ICertificateQueryResult[]>(this.resourceUrl, {params});
  }
}
